export default __webpack_public_path__ + "static/media/Jai-Vilas02.281ebf7b.jpg";